<template>
  <div>
    <KarinDocument></KarinDocument>
    <KarinResolve></KarinResolve>
    <KarinComments></KarinComments>

    <AlertDismiss ref="alertDismiss"></AlertDismiss>
    <b-overlay :show="isBusy">
      <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
        select-mode="single" selectable @row-selected="onRowSelected" show-empty>
        >
        <template #empty>
          <b-card v-if="dateQuery" class="text-center my-2 fs-5">
              No se realizaron denuncias en el periodo seleccionado
          </b-card>
          <b-card v-else-if="searchQuery" class="text-center my-2 fs-5">
              No hay denuncias que coincidan con los criterios de búsqueda
          </b-card>
          <b-card v-else class="text-center my-2 fs-5">
              Aún no se ha recibido ninguna denuncia
          </b-card>
        </template>
        <!--icono de carque de tabla-->
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando datos de tabla...</strong>
          </div>

        </template>

        <!--botones de eliminar y editar -->
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <div class="d-flex align-items-center">
              <b-button @click="openModalKarinDocument" type="button" variant="outline-secondary"
                v-b-tooltip.hover="'Mostrar evidencia'" size="sm">
                <b-icon icon="file-earmark-medical-fill" font-scale="1"></b-icon>
              </b-button>

              <button @click="openModalKarinComments" type="button" class="btn btn-outline-secondary btn-sm ms-2"
                v-b-tooltip.hover="'Comentarios'">
                <b-icon icon="chat-left-text" font-scale="1"></b-icon>
              </button>

              <button
                v-if="selected.approval === null"
                v-permission="'karin-resolver'"
                @click="openModalKarinResolve" type="button" class="btn btn-outline-secondary btn-sm ms-2"
                v-b-tooltip.hover="'Procesar denuncia'">
                <b-icon icon="check-square-fill" font-scale="1"></b-icon>
              </button>
            </div>

          </template>
          <template v-else>
            <b-icon icon="three-dots" font-scale="1" class="icone-not-select"></b-icon>
          </template>
        </template>

        <template #cell(approval)="row">
          <span v-if="row.item.approval === null" class="badge bg-dark">
            Pendiente
          </span>
          <span v-else-if="row.item.approval.approved" class="badge bg-success">
            Aprobado
          </span>
          <span v-else class="badge bg-danger">
            Rechazado
          </span>
        </template>

        <!--boton de detalles -->
        <template #cell(detalle)="row">
          <b-button size="sm" @click="row.toggleDetails" variant="outline-secondary" class="mr-2">
            <div v-if="row.detailsShowing" v-b-tooltip.hover title="Ocultar">
              <b-icon icon="eye-slash-fill" font-scale="1"></b-icon>
            </div>
            <div v-else v-b-tooltip.hover title="Ver">
              <b-icon icon="eye-fill" font-scale="1"></b-icon>
            </div>
          </b-button>
        </template>

        <template #cell(preventive)="row">
          <span v-if="row.item.preventive" class="badge bg-danger">
            Solicitadas
          </span>
          <span v-else class="badge bg-secondary">
            No solicitadas
          </span>
        </template>


        <!--cuerpo de detalle-->
        <template #row-details="row">
          <KarinDetails :denounce="row.item"></KarinDetails>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import KarinDocument from "@/components/KarinLaw/KarinList/KarinTable/Karin-document.vue";
import KarinComments from "@/components/KarinLaw/KarinList/KarinTable/Karin-comments.vue";
import KarinResolve from './KarinTable/Karin-resolve.vue';
import KarinDetails from './KarinTable/Karin-details.vue';
import { mapActions, mapGetters } from 'vuex';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { formatDateTime, formatRut } from '@/plugins/complianceScripts/index.js'


export default {
  name: 'KarinTable',

  data() {
    return {
      comment: null,
      isBusy: false,
      items: [],
      selected: null,

      endDate: null,
      startDate: null,
      searchQuery: '',

      isUploadingForm: false,

      fields: [
        { key: 'accuserNombre', label: 'Nombre afectado' },
        { key: 'accuserCorreo', label: 'Correo afectado' },
        { key: 'accuserRut', label: 'RUT afectado', formatter: formatRut },
        { key: 'denunciationType', label: 'Tipo de denuncia' },
        { key: 'approval', label: 'Estado' },
        { key: 'detalle', label: 'Detalle' },
        { key: 'selected', label: 'Opciones'},
      ],
      dateQuery: null,

    }
  },

  components: {
    KarinDocument,
    KarinComments,
    KarinResolve,
    AlertDismiss,
    KarinDetails,
  },

  async mounted() {
    this.$eventBus.$on(EventNames.PaginationFilterKarinDenounce, async (query) => {
      this.processingTable();

      let page = query.page - 1; //se resta 1 por que el indice comienza en 0
      let pageSize = query.pageSize;

      await this.getAllKarinDenunciation(page, pageSize);

      this.processingTable();
    });

    this.$eventBus.$on(EventNames.FilterKarinDenounceByDate, async (query) => {
      this.processingTable();
      this.dateQuery = query;

      await this.getAllKarinDenunciationByDate(query);

      this.processingTable();
    });   

    this.$eventBus.$on(EventNames.CreatedKarinDenunciation, async (query) => {
      this.processingTable();

      let page = query.page - 1;
      let pageSize = query.pageSize;

      await this.getAllKarinDenunciation(page, pageSize);

      this.processingTable();
    });

    this.$eventBus.$on(EventNames.ClearFilterKarinDenounce, async () => {
      this.processingTable();
      this.dateQuery = null;
      this.searchQuery = '';

      await this.getAllKarinDenunciation(0, InitPageSize.KarinDenouncePageSize);

      this.processingTable();
    });

    this.$eventBus.$on(EventNames.ResolvedKarinDenunciation, async (query) => {
      this.processingTable();

      let page = query.page - 1;
      let pageSize = query.pageSize;

      await this.getAllKarinDenunciation(page, pageSize);

      this.processingTable();
    });

    this.$eventBus.$on(EventNames.FilterKarinDenunciationAfterSearch, (query) => {
      this.processingTable();

      this.searchQuery = query

      this.processingTable();
    });

  },

  computed: {
    ...mapGetters(["getRole"]),

    filteredItems() {
      let filtered = this.items;

      if (this.searchQuery) {
        filtered = this.filterForSearch(filtered, this.searchQuery)
      }

      return filtered;
    },

    showResolveButton() {
      if (!this.selected) {
        return false;
      }
      return this.selected.item.approval === null;
    }
  },

  methods: {
    formatDateTime,
    ...mapActions([
      "allKarinDenunciaion",
      "allKarinDenunciationByDate",
      "addCommentKarinDenunciation"
    ]),

    async getAllKarinDenunciation(page, pageSize) {
      let result = await this.allKarinDenunciaion({ page: page, pageSize: pageSize, });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }

      this.items = this.convertData(result.data);
    },

    async getAllKarinDenunciationByDate(query) {
      this.items = []

      let result = await this.allKarinDenunciationByDate({
        startDate: query.startDate,
        endDate: query.endDate
      })

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }

      this.items = this.convertData(result.data);
    },

    convertData(data) {
      return data.map(item => {
        let user = item.affected ? item.affected : item.accuser

        return {
          accuserNombre: user.name,
          accuserCorreo: user.mail,
          accuserRut: user.rut,
          id: item.id,
          preventive: item.preventive,
          denunciationType: item.denunciationType.name,
          descripcion: item.descripcion,
          creationDate: item.creationDate,
          document: item.document,
          approval: item.approval,
          accuser: item.accuser,
          reported: item.peopleReported,
          external: item.externallink,
          affected: item.affected
        }
      });
    },

    processingTable() {
      this.isBusy = !this.isBusy
    },

    filterForSearch(items, searchQuery) {
      const normalizedQuery = searchQuery.toLowerCase().trim();

      return items.filter(item =>
        Object.values(item).some(value =>
          value.toString().toLowerCase().includes(normalizedQuery)
        )
      );
    },

    onRowSelected(items) {
      this.selected = items[0] ?? null;
    },

    openModalKarinDocument() {
      if (this.selected.document) {
        this.$eventBus.$emit(EventNames.OpenModalKarinDocumentLink, this.selected.document.route);
      } else {
        this.$refs.alertDismiss.showAlert('Esta denuncia no tiene documento asociado');
      }
    },

    openModalKarinComments() {
      this.$eventBus.$emit(EventNames.OpenModalKarinComments, this.selected.id);
    },

    openModalKarinResolve() {
      this.$eventBus.$emit(EventNames.OpenModalKarinResolve, this.selected.id);
    },
  }
}
</script>

<style scoped>
hr {
  margin-top: 0.4rem;
  margin-bottom: 0.3rem;
}
</style>
